import React, { useState } from "react";
import FormInput from "../../reusable/CustomInput/formInput";
import allCountries from "../../assets/constants/country-state-city/country.json";
// import allStates from "../../assets/constants/country-state-city/state.json";
// import allCities from "../../assets/constants/country-state-city/city.json";
import CustomModal from "../../reusable/CustomModal/CustomModal";
// import SelectInput from "../../reusable/CustomSelectbox/SelectInput";
// import { Country, State, City } from "country-state-city";

import SelectOptionsInput from "../../reusable/selectOptionInput";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { getCountryStates, getStateCity } from "../../api/common";
import { useDispatch } from "react-redux";
const AddAddressModal = ({
  visible,
  header,
  setVisible,
  footer,
  register,
  SubmitHandler,
  errors,
  formData,
  setValue,
  loader,
}) => {
  const dispatch = useDispatch();
  // const countries = Country.getAllCountries();

  // const updatedCountries = countries.map((country) => ({
  //   name: country.name,
  //   value: country.id,
  //   ...country,
  // }));
  //  console.log("updatedCountries===>", updatedCountries)
  const [statesList, setStatesList] = useState([]);
  const [statesList1, setStatesList1] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (formData) {
      setValue("customerName", formData?.customerName);
      setValue("customerPhone", formData?.customerPhone);
      setValue("pinCode", formData?.pinCode);
      // setValue("locality", formData?.locality);
      setValue("country", formData?.country);

      let obj = {
        countryCode: formData?.country,
      };
      // localStorage.setItem("countryCode", value);
      dispatch(getCountryStates(obj))
        .then((res) => {
          setStatesList(res?.data);
          setTimeout(() => setValue("state", formData?.state), 200)
        })
        .catch((err) => {
          console.log("err", err);
        });
      let obj1 = {
        countryCode: formData?.country,
        stateCode: formData?.state,
      };
      dispatch(getStateCity(obj1))
        .then((res) => {
          setCityList(res?.data);
          setTimeout(() => setValue("city", formData?.city), 300)

          // setLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
        });

      setValue("alternatePhone", formData?.alternatePhone);
      // setValue("landMark", formData?.landMark);
      setValue("address", formData?.address);
      // const statesData = State.getStatesOfCountry(formData?.country);
      // setStatesList(statesData);
    }
  }, [formData]);

  const compare = (a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  };

  // const getStatesOfCountries = (countryCode) => {
  //   if (!countryCode) return [];
  //   const states = allStates.filter((value) => {
  //     return value.countryCode === countryCode;
  //   });
  //   return states.sort(compare);
  // };
  // const getCitiesOfState = (countryCode, stateCode) => {
  //   if (!stateCode || !countryCode) return [];
  //   const cities = allCities.filter((value) => {
  //     return value.countryCode === countryCode && value.stateCode === stateCode;
  //   });
  //   return cities.sort(compare);
  // };

  const handleOptionCLick = (e) => {
    const { value, name } = e.target;
    if (name === "country") {
      setValue("state", null);
      setValue("city", null);
      setStatesList([]);
      setCityList([]);
      let obj = {
        countryCode: value,
      };
      localStorage.setItem("countryCode", value);
      dispatch(getCountryStates(obj))
        .then((res) => {
          setStatesList(res?.data);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
    if (name === "state") {
      setLoading(true);
      setValue("city", null);
      setCityList([]);
      let obj = {
        countryCode: localStorage?.countryCode,
        stateCode: value,
      };
      dispatch(getStateCity(obj))
        .then((res) => {
          setCityList(res?.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };
  useEffect(() => {
    if (formData?.country) {
      // const statesData = getStatesOfCountries(formData?.country);
      // setStatesList1(statesData);
      // setStatesList(statesData);
    }
  }, [formData?.country]);

  useEffect(() => {
    if (statesList1.length > 0 && formData?.state) {
      const country = statesList1.find(
        (state) => state.isoCode === formData?.state
      );
      // const cityData = getCitiesOfState(country.countryCode, formData?.state);
      // setCityList(cityData);
    }
  }, [statesList1, formData?.state]);

  useEffect(() => {
    if (statesList1?.length > 0) {
      setValue("state", formData?.state);
      setValue("city", formData?.city);
    }
  }, [count]);

  useEffect(() => {
    if (statesList1?.length > 0)
      setTimeout(() => {
        setCount(count + 1);
      }, 300);
  }, [statesList1?.length]);

  return (
    <>
      <CustomModal
        visible={visible}
        title={header}
        onClose={setVisible}
        onClickSubmit={SubmitHandler}
        width={600}
        className="filter-modal "
        footer={footer}
        loader={loader}
        
      >
        <div className="row my-4">
          <div className="col-md-6 mb-3">
            <div className="custom_icon_input position-relative margin_above ">
              <FormInput
                label={"Name"}
                type="text"
                className="form-control"
                placeholder="Name"
                register={register}
                name="customerName"
                rule={{ required: "This field is required!" }}
                error={errors?.customerName ? true : false}
                errorMessage={errors?.customerName?.message}
              />
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="custom_icon_input position-relative margin_above">
              <FormInput
                label={"Phone Number"}
                type="number"
                className="form-control"
                placeholder="Phone Number"
                register={register}
                name="customerPhone"
                rule={{ required: "This field is required!" }}
                error={errors?.customerPhone ? true : false}
                errorMessage={errors?.customerPhone?.message}
              />
            </div>
          </div>
          <div className="col-md-6 mb-3 ">
            <div className="custom_icon_input position-relative margin_above">
              <FormInput
                label={"Postal code"}
                type="text"
                className="form-control"
                placeholder="Postal code"
                register={register}
                name="pinCode"
                rule={{ required: "This field is required!" }}
                error={errors?.pinCode ? true : false}
                errorMessage={errors?.pinCode?.message}
              />
            </div>
          </div>
          {/* <div className="col-md-6 mb-3">
            <div className="custom_icon_input position-relative margin_above">
              <FormInput
                label={"Locality"}
                type="text"
                className="form-control"
                placeholder="Locality"
                register={register}
                name="locality"
                rule={{ required: "This field is required!" }}
                error={errors?.locality ? true : false}
                errorMessage={errors?.locality?.message}
              />
            </div>
          </div> */}
          <div className="col-md-6 mb-3 ">
            <div className="custom_icon_input position-relative margin_above">
              <SelectOptionsInput
                label={"Country"}
                error={errors?.country ? true : false}
                errorMessage={errors?.country?.message}
                options={allCountries}
                name="country"
                selectedValue={"Select Country"}
                // selectedValue={"Country"}
                onOptionClick={handleOptionCLick}
                {...register("country", { required: true })}
              />
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="custom_icon_input position-relative margin_above">
              <SelectOptionsInput
                label={"State"}
                error={errors?.state ? true : false}
                errorMessage={errors?.state?.message}
                options={statesList}
                name="state"
                onOptionClick={handleOptionCLick}
                // selectedValue={"State"}
                selectedValue={"Select State"}
                {...register("state", { required: true })}
              />
            </div>
          </div>
          <div className="col-md-6 mb-3 ">
            {loading ? (
              <div style={{ margin: "0", padding: "0" }}>
                <label>City</label>
                <div className="form-control d-flex justify-content-between">
                  <h6 style={{ fontWeight: "100" }}>Select City</h6>
                  <div
                    className="spinner-border text-primary"
                    role="status"
                  ></div>
                </div>{" "}
              </div>
            ) : (
              <div className="custom_icon_input position-relative margin_above">
                <SelectOptionsInput
                  label={"City"}
                  error={errors?.city ? true : false}
                  errorMessage={errors?.city?.message}
                  options={cityList}
                  name="city"
                  selectedValue={"Select City"}
                  {...register("city", { required: true })}
                />
              </div>
            )}
          </div>
          <div className="col-md-6 mb-3 ">
            <div className="custom_icon_input position-relative margin_above">
              <FormInput
                label={"Alternate Number"}
                type="number"
                className="form-control"
                placeholder="Alternate Number"
                register={register}
                name="alternatePhone"
              // rule={{ required: "This field is required!" }}
              // error={errors?.alternatePhone ? true : false}
              // errorMessage={errors?.alternatePhone?.message}
              />
            </div>
          </div>
          {/* <div className="col-md-6 mb-3 ">
            <div className="custom_icon_input position-relative margin_above">
              <FormInput
                label={"Landmark"}
                type="text"
                className="form-control"
                placeholder="Landmark"
                register={register}
                name="landMark"
                rule={{ required: "This field is required!" }}
                error={errors?.landMark ? true : false}
                errorMessage={errors?.landMark?.message}
              />
            </div>
          </div> */}
          <div className="col-md-12 ">
            <div className="custom_icon_input position-relative margin_above">
              <FormInput
                label={"Address"}
                rows="3"
                id="pre_requisites"
                name="address"
                placeholder="Address (Area and Street) "
                textArea="true"
                height="140px"
                register={register}
                rule={{ required: "This field is required!" }}
                error={errors?.address ? true : false}
                errorMessage={errors?.address?.message}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default AddAddressModal;
